import { useEffect } from "react";
import L from "leaflet";
import "leaflet-control-geocoder";
import { useMap } from "react-leaflet";


const MapGeocoder = () => {
  const map = useMap();

  useEffect(() => {
    L.Control.geocoder({
      defaultMarkGeocode: false,
    })
      .on("markgeocode", function (e) {
        var latlng = e.geocode.center;
        L.marker(latlng, {icon: DefaultIcon}).addTo(map).bindPopup(e.geocode.name).openPopup();
        map.fitBounds(e.geocode.bbox);
      })
      .addTo(map);

   
  }, [map]);

  return null;
};

let DefaultIcon = L.icon({
  iconUrl: "/marker-icon.png",
  iconSize: [25, 41],
  iconAnchor: [10, 41],
  popupAnchor: [2, -40],
});
export default MapGeocoder;
